import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import './PublicResults.css';
import {fishSpeciesList, boatList} from '../refs/lists';

function PublicResults () {

  const [alignment, setAlignment] = useState('tournament');
  const [catchList, setCatchList] = useState([]);
  const [sailfishResults, setSailfishResults] = useState([]);
  const [sailfishTitle, setSailfishTitle] = useState("Sailfish");
  const [sailfishDescription, setSailfishDescription] = useState("First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.");
  const [blueMarlinResults, setBlueMarlinResults] = useState([]);
  const [blueMarlinTitle, setBlueMarlinTitle] = useState("Blue Marlin");
  const [blueMarlinDescription, setBlueMarlinDescription] = useState("First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.");
  const [whiteMarlinResults, setWhiteMarlinResults] = useState([]);
  const [whiteMarlinTitle, setWhiteMarlinTitle] = useState("White Marlin");
  const [whiteMarlinDescription, setWhiteMarlinDescription] = useState("First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.");
  const [spearfishResults, setSpearfishResults] = useState([]);
  const [spearfishTitle, setSpearfishTitle] = useState("Spearfish");
  const [spearfishDescription, setSpearfishDescription] = useState("First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.");
  const [dolphinResults, setDolphinResults] = useState([]);
  const [dolphinTitle, setDolphinTitle] = useState("Dolphin (Dorado, Mahi)");
  const [dolphinDescription, setDolphinDescription] = useState("Heaviest catch. First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.");
  const [wahooResults, setWahooResults] = useState([]);
  const [wahooTitle, setWahooTitle] = useState("Wahoo");
  const [wahooDescription, setWahooDescription] = useState("Heaviest catch. First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.");
  const [tunaResults, setTunaResults] = useState([]);
  const [tunaTitle, setTunaTitle] = useState("Tuna");
  const [tunaDescription, setTunaDescription] = useState("Heaviest catch. First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.");
  const [billfishDay1Results, setBillfishDay1Results] = useState([]);
  const [billfishDay1Title, setBillfishDay1Title] = useState("Billfish Day 1");
  const [billfishDay1Description, setBillfishDay1Description] = useState("Winner takes all each day. Earliest catch for tie-breakers.");
  const [billfishDay2Results, setBillfishDay2Results] = useState([]);
  const [billfishDay2Title, setBillfishDay2Title] = useState("Billfish Day 2");
  const [billfishDay2Description, setBillfishDay2Description] = useState("Winner takes all each day. Earliest catch for tie-breakers.");
  const [billfishDay3Results, setBillfishDay3Results] = useState([]);
  const [billfishDay3Title, setBillfishDay3Title] = useState("Billfish Day 3");
  const [billfishDay3Description, setBillfishDay3Description] = useState("Winner takes all each day. Earliest catch for tie-breakers.");
  const [billfishOverallResults, setBillfishOverallResults] = useState([]);
  const [billfishOverallTitle, setBillfishOverallTitle] = useState("Overall Billfish");
  const [billfishOverallDescription, setBillfishOverallDescription] = useState("First place takes 70% of pot, second place takes 30%. Earliest catch for tie-breakers.");
  const [grandChampionResults, setGrandChampionResults] = useState([]);
  const [grandChampionTitle, setGrandChampionTitle] = useState("Tournament Grand Champion");
  const [grandChampionDescription, setGrandChampionDescription] = useState("Winner takes all. Earliest catch for tie-breakers.");
  const [recentCatchTitle, setRecentCatchTitle] = useState("All Catches")
  const [recentCatchList, setRecentCatchList] = useState([])
  const [grandSlamResults, setGrandSlamResults] = useState([]);
  const [numCatches, setNumCatches] = useState();
  const [numBillfish, setNumBillfish] = useState();
  const [numBlueMarlin, setNumBlueMarlin] = useState();
  const [numWhiteMarlin, setNumWhiteMarlin] = useState();
  const [numSailfish, setNumSailfish] = useState();
  const [numSpearfish, setNumSpearfish] = useState();
  const [numDolphin, setNumDolphin] = useState();
  const [numWahoo, setNumWahoo] = useState();
  const [numTuna, setNumTuna] = useState();

  const handleTabChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  useEffect(() => {

    // Get Sailfish
    let sailfishParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Sailfish",
      })
    }
    const getSailfish = async () =>{
      let response = await axios(sailfishParams);  
      setNumSailfish(response.data.length);
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});

        result.sort((a, b) => b.points - a.points);
        setSailfishResults(result.slice(0,5))
      }
    }
    getSailfish();

    // Get Blue Marlin
    let blueMarlinParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Blue Marlin",
      })
    }
    const getBlueMarlin = async () =>{
      let response = await axios(blueMarlinParams);  
      var result = [];
      setNumBlueMarlin(response.data.length);
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        setBlueMarlinResults(result.slice(0,5))
      }
    }
    getBlueMarlin();

    // Get White Marlin
    let whiteMarlinParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "White Marlin",
      })
    }
    const getWhiteMarlin = async () =>{
      let response = await axios(whiteMarlinParams);  
      setNumWhiteMarlin(response.data.length);
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        setWhiteMarlinResults(result.slice(0,5));
      }
    }
    getWhiteMarlin();

    // Get Speafish
    let spearfishParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Spearfish",
      })
    }
    const getSpearfish = async () =>{
      let response = await axios(spearfishParams);  
      setNumSpearfish(response.data.length);
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        setSpearfishResults(result.slice(0,5))
      }
    }
    getSpearfish();

    // Get Dolphin (Dorado, Mahi)
    let dolphinParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Dolphin (Dorado, Mahi)",
      })
    }
    const getDolphin = async () =>{
      let response = await axios(dolphinParams);  
      var result = [];
      setNumDolphin(response.data.length);
      if(response.data.length > 0) {
        result = response.data.sort((a, b) => b.points - a.points);
        setDolphinResults(result.slice(0,5))
      }
    }
    getDolphin();
    
    // Get Wahoo
    let wahooParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Wahoo",
      })
    }
    const getWahoo = async () =>{
      let response = await axios(wahooParams);  
      var result = [];
      setNumWahoo(response.data.length);
      if(response.data.length > 0) {
        result = response.data.sort((a, b) => b.points - a.points);
        setWahooResults(result.slice(0,5))
      }
    }
    getWahoo();

    // Get Tuna
    let tunaParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpecies',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: "Tuna",
      })
    }
    const getTuna = async () =>{
      let response = await axios(tunaParams);  
      var result = [];
      setNumTuna(response.data.length);
      if(response.data.length > 0) {
        result = response.data.sort((a, b) => b.points - a.points);
        setTunaResults(result.slice(0,5))
      }
    }
    getTuna();

    // Get Billfish Day 1
    let billfishDay1Params = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpeciesByDay',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish1: "Blue Marlin",
        fish2: "White Marlin",
        fish3: "Sailfish",
        fish4: "Spearfish",
        date: "2023-07-13",
      })
    }
    const getBillfishDay1 = async () =>{
      let response = await axios(billfishDay1Params);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        setBillfishDay1Results(result.slice(0,5))
      }
    }
    getBillfishDay1();

    // Get Billfish Day 2
    let billfishDay2Params = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpeciesByDay',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish1: "Blue Marlin",
        fish2: "White Marlin",
        fish3: "Sailfish",
        fish4: "Spearfish",
        date: "2023-07-14",
      })
    }
    const getBillfishDay2 = async () =>{
      let response = await axios(billfishDay2Params);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        setBillfishDay2Results(result.slice(0,5));
      }
    }
    getBillfishDay2();
    
    // Get Billfish Day 3
    let billfishDay3Params = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getCatchBySpeciesByDay',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish1: "Blue Marlin",
        fish2: "White Marlin",
        fish3: "Sailfish",
        fish4: "Spearfish",
        date: "2023-07-15",
      })
    }
    const getBillfishDay3 = async () =>{
      let response = await axios(billfishDay3Params);  
      var result = [];
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        setBillfishDay3Results(result.slice(0,5))
      }
    }
    getBillfishDay3();

    // Get overall billfish and grand slam
    let billfishOverallParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllBillfish',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish1: "Blue Marlin",
        fish2: "White Marlin",
        fish3: "Sailfish",
        fish4: "Spearfish",
      })
    }
    const getBillfishOverall = async () =>{
      let response = await axios(billfishOverallParams);  
      var result = [];
      setNumBillfish(response.data.length);
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        setBillfishOverallResults(result.slice(0,5))
      }
    }
    getBillfishOverall();

    // Get tournament grand champion
    let grandChampionParams = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllPointFish',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish1: "Blue Marlin",
        fish2: "White Marlin",
        fish3: "Sailfish",
        fish4: "Spearfish",
        fish5: "Dolphin (Dorado, Mahi)",
        fish6: "Wahoo",
        fish7: "Tuna",
      })
    }
    const getGrandChampion = async () =>{
      let response = await axios(grandChampionParams);  
      var result = [];
      setNumCatches(response.data.length);
      if(response.data.length > 0) {
        response.data.reduce(function(res, value) {
          if (!res[value.boatName]) {
            res[value.boatName] = { boatName: value.boatName, points: 0 };
            result.push(res[value.boatName])
          }
          res[value.boatName].points += value.points;
          return res;
        }, {});
        result.sort((a, b) => b.points - a.points);
        setGrandChampionResults(result.slice(0,5))
      }
    }
    getGrandChampion();

    let recentCatchParams = {
      method: 'GET',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getRecentCatches',
      headers: {'Content-Type': 'application/json'},
    }
    const getRecentCatches = async () =>{
      let response = await axios(recentCatchParams);  
      if (response.data.length > 0) {
        setRecentCatchList(response.data)
      }
    }
    getRecentCatches();

    // Get grand slam
    let grandSlamWinners = []
    boatList.forEach((boat, i) => {

      const getGrandSlam = async () => {
        let response = await axios(grandSlamParams);  
        var result = [];
        if(response.data.length > 0) {

          let fullCatchList = response.data;

          var sailfishCaught = fullCatchList.filter(function(v, i) {
            return (v["fish"] == "Sailfish");
          })
          var whiteMarlinCaught = fullCatchList.filter(function(v, i) {
            return (v["fish"] == "White Marlin");
          })
          var blueMarlinCaught = fullCatchList.filter(function(v, i) {
            return (v["fish"] == "Blue Marlin");
          })

          if (
            (sailfishCaught.length > 0) &&
            (blueMarlinCaught.length > 0) &&
            (whiteMarlinCaught.length > 0)
          ) {

            let grandSlamObject = {}
            grandSlamObject['boatName'] = boat
            grandSlamObject['sailfishTime'] = sailfishCaught[0]['date'].split("T")[0] + " " + sailfishCaught[0]['time']
            grandSlamObject['blueMarlinTime'] = blueMarlinCaught[0]['date'].split("T")[0] + " " + blueMarlinCaught[0]['time']
            grandSlamObject['whiteMarlinTime'] = whiteMarlinCaught[0]['date'].split("T")[0] + " " + whiteMarlinCaught[0]['time']
            console.log(boat, " hit the grand slam!");
            console.log(sailfishCaught);
            console.log(whiteMarlinCaught);
            console.log(blueMarlinCaught);
            grandSlamWinners = [...grandSlamWinners, grandSlamObject];
            setGrandSlamResults(grandSlamWinners)
          }
        }
      }

      let grandSlamParams = {
        method: 'POST',
        url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getBillfishByBoat',
        headers: {'Content-Type': 'application/json'},
        data: JSON.stringify({
          fish1: "Blue Marlin",
          fish2: "White Marlin",
          fish3: "Sailfish",
          fish4: "Spearfish",
          name: boat
        })
      }

      getGrandSlam();

      console.log('Grand slam winners:')
      console.log(grandSlamWinners);

    })

  }, []);

  return <>
    <ToggleButtonGroup
        color="primary"
        value={alignment}
        exclusive
        onChange={handleTabChange}
        aria-label="Platform"
      >
        <ToggleButton value="tournament">Tournament Standings</ToggleButton>
        {/* <ToggleButton value="pot">Fish Pot Standings</ToggleButton> */}
        <ToggleButton value="stats">Tournament Stats</ToggleButton>
      </ToggleButtonGroup>
      { alignment == "tournament" ? (
        <>
          <h2>Tournament Standings</h2>
          <p><em>* results not yet final *</em></p>
          <div className="container">

          <div className="resultsTable">
              <div className="resultsContent">
                <h3>{grandChampionTitle}</h3>
              </div>
              {grandChampionResults.length > 0 ? (
              <>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Points</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {grandChampionResults.map((team, i) => {
                      return (
                        <Tr>
                          <Td>{i+1}</Td>
                          <Td>{team.boatName}</Td>
                          <Td>{team.points}</Td>
                        </Tr>
                      )
                    })}
                  </Tbody>
                </Table>
              </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>#</Th>
                        <Th>Team</Th>
                        <Th>Points</Th>
                      </Tr>
                    </Thead>
                  </Table>
                  <p>No fish caught yet</p>
                </>
              )}
              <p>{grandChampionDescription}</p>
            </div>
            <br/>
            <br/> 

            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{billfishOverallTitle}</h3>
              </div>
              <Table>
                <Thead>
                  <Tr>
                    <Th>#</Th>
                    <Th>Team</Th>
                    <Th>Points</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>1</Td>
                    <Td>Rebecca</Td>
                    <Td>1850</Td>
                  </Tr>
                  <Tr>
                    <Td>2</Td>
                    <Td>Backlash74</Td>
                    <Td>1250</Td>
                  </Tr>
                  <Tr>
                    <Td>3</Td>
                    <Td>Poured Out</Td>
                    <Td>1250</Td>
                  </Tr>
                  <Tr>
                    <Td>4</Td>
                    <Td>Vamonos - Clement</Td>
                    <Td>1150</Td>
                  </Tr>
                  <Tr>
                    <Td>5</Td>
                    <Td>Ambush</Td>
                    <Td>850</Td>
                  </Tr>
                </Tbody>
              </Table>
              <p>{billfishOverallDescription}</p>
            </div>
            <br/>
            <br/> 

            <div className="resultsTable">
              <div className="resultsContent">
                <h3>Grand Slams</h3>
              </div>
              <>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Blue Marlin</Th>
                      <Th>White Marlin</Th>
                      <Th>Sailfish</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>1</Td>
                      <Td>Poured Out</Td>
                      <Td>2023-07-14 16:17:00</Td>
                      <Td>2023-07-14 15:05:00</Td>
                      <Td>2023-07-13 16:55:00</Td>
                    </Tr>
                    <Tr>
                      <Td>2</Td>
                      <Td>Vamonos - Clement</Td>
                      <Td>2023-07-14 19:22:00</Td>
                      <Td>2023-07-14 13:35:00</Td>
                      <Td>2023-07-15 06:56:00</Td>
                    </Tr>
                    <Tr>
                      <Td>3</Td>
                      <Td>Backlash74</Td>
                      <Td>2023-07-14 15:26:00</Td>
                      <Td>2023-07-15 08:02:00</Td>
                      <Td>2023-07-14 08:00:00</Td>
                    </Tr>
                    <Tr>
                      <Td>4</Td>
                      <Td>Instigator</Td>
                      <Td>2023-07-15 09:25:00</Td>
                      <Td>2023-07-13 15:13:00</Td>
                      <Td>2023-07-13 17:27:00</Td>
                    </Tr>
                    <Tr>
                      <Td>5</Td>
                      <Td>See-Mah</Td>
                      <Td>2023-07-14 17:13:00</Td>
                      <Td>2023-07-15 09:43:00</Td>
                      <Td>2023-07-13 16:26:00</Td>
                    </Tr>
                  </Tbody>
                </Table>
              </>
              <p>First boat to complete the grand slam takes all.</p>
            </div>
            <br/>
            <br/> 

            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{billfishDay1Title}</h3>
              </div>
              {billfishDay1Results.length > 0 ? (
              <>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Points</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {billfishDay1Results.map((team, i) => {
                      return (
                        <Tr>
                          <Td>{i+1}</Td>
                          <Td>{team.boatName}</Td>
                          <Td>{team.points}</Td>
                        </Tr>
                      )
                    })}
                  </Tbody>
                </Table>
              </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>#</Th>
                        <Th>Team</Th>
                        <Th>Points</Th>
                      </Tr>
                    </Thead>
                  </Table>
                  <p>No fish caught yet</p>
                </>
              )}
              <p>{billfishDay1Description}</p>
            </div>
            <br/>
            <br/>

            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{billfishDay2Title}</h3>
              </div>
              {billfishDay2Results.length > 0 ? (
              <>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Points</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {billfishDay2Results.map((team, i) => {
                      return (
                        <Tr>
                          <Td>{i+1}</Td>
                          <Td>{team.boatName}</Td>
                          <Td>{team.points}</Td>
                        </Tr>
                      )
                    })}
                  </Tbody>
                </Table>
              </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>#</Th>
                        <Th>Team</Th>
                        <Th>Points</Th>
                      </Tr>
                    </Thead>
                  </Table>
                  <p>No fish caught yet</p>
                </>
              )}
              <p>{billfishDay2Description}</p>
            </div>
            <br/>
            <br/>

            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{billfishDay3Title}</h3>
              </div>
              <Table>
                <Thead>
                  <Tr>
                    <Th>#</Th>
                    <Th>Team</Th>
                    <Th>Points</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>1</Td>
                    <Td>Vamonos - Clement</Td>
                    <Td>550</Td>
                  </Tr>
                  <Tr>
                    <Td>2</Td>
                    <Td>Backlash74</Td>
                    <Td>550</Td>
                  </Tr>
                  <Tr>
                    <Td>3</Td>
                    <Td>Stabilized</Td>
                    <Td>500</Td>
                  </Tr>
                  <Tr>
                    <Td>4</Td>
                    <Td>Rebecca</Td>
                    <Td>500</Td>
                  </Tr>
                  <Tr>
                    <Td>5</Td>
                    <Td>Instigator</Td>
                    <Td>400</Td>
                  </Tr>
                </Tbody>
              </Table>
              <p>{billfishDay3Description}</p>
            </div>
            <br/>
            <br/>

            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{blueMarlinTitle}</h3>
              </div>
              {blueMarlinResults.length > 0 ? (
              <>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Points</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {blueMarlinResults.map((team, i) => {
                      return (
                        <Tr>
                          <Td>{i+1}</Td>
                          <Td>{team.boatName}</Td>
                          <Td>{team.points}</Td>
                        </Tr>
                      )
                    })}
                  </Tbody>
                </Table>
              </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>#</Th>
                        <Th>Team</Th>
                        <Th>Points</Th>
                      </Tr>
                    </Thead>
                  </Table>
                  <p>No fish caught yet</p>
                </>
              )}
              <p>{blueMarlinDescription}</p>
            </div>
            <br/>
            <br/>
            
            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{whiteMarlinTitle}</h3>
              </div>
              {whiteMarlinResults.length > 0 ? (
              <>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Points</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {whiteMarlinResults.map((team, i) => {
                      return (
                        <Tr>
                          <Td>{i+1}</Td>
                          <Td>{team.boatName}</Td>
                          <Td>{team.points}</Td>
                        </Tr>
                      )
                    })}
                  </Tbody>
                </Table>
              </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>#</Th>
                        <Th>Team</Th>
                        <Th>Points</Th>
                      </Tr>
                    </Thead>
                  </Table>
                  <p>No fish caught yet</p>
                </>
              )}
              <p>{whiteMarlinDescription}</p>
            </div>
            <br/>
            <br/>

            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{sailfishTitle}</h3>
              </div>
              {sailfishResults.length > 0 ? (
              <>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Points</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {sailfishResults.map((team, i) => {
                      return (
                        <Tr>
                          <Td>{i+1}</Td>
                          <Td>{team.boatName}</Td>
                          <Td>{team.points}</Td>
                        </Tr>
                      )
                    })}
                  </Tbody>
                </Table>
              </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>#</Th>
                        <Th>Team</Th>
                        <Th>Points</Th>
                      </Tr>
                    </Thead>
                  </Table>
                  <p>No fish caught yet</p>
                </>
              )}
              <p>{sailfishDescription}</p>
            </div>
            <br/>
            <br/>
            
            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{spearfishTitle}</h3>
              </div>
              {spearfishResults.length > 0 ? (
              <>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Points</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {spearfishResults.map((team, i) => {
                      return (
                        <Tr>
                          <Td>{i+1}</Td>
                          <Td>{team.boatName}</Td>
                          <Td>{team.points}</Td>
                        </Tr>
                      )
                    })}
                  </Tbody>
                </Table>
              </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>#</Th>
                        <Th>Team</Th>
                        <Th>Points</Th>
                      </Tr>
                    </Thead>
                  </Table>
                  <p>No fish caught yet</p>
                </>
              )}
              <p>{spearfishDescription}</p>
            </div>
            <br/>
            <br/>
            
            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{dolphinTitle}</h3>
              </div>
              {dolphinResults.length > 0 ? (
              <>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Points</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {dolphinResults.map((team, i) => {
                      return (
                        <Tr>
                          <Td>{i+1}</Td>
                          <Td>{team.boatName}</Td>
                          <Td>{team.points}</Td>
                        </Tr>
                      )
                    })}
                  </Tbody>
                </Table>
              </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>#</Th>
                        <Th>Team</Th>
                        <Th>Points</Th>
                      </Tr>
                    </Thead>
                  </Table>
                  <p>No fish caught yet</p>
                </>
              )}
              <p>{dolphinDescription}</p>
            </div>
            <br/>
            <br/>
            
            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{wahooTitle}</h3>
              </div>
              {wahooResults.length > 0 ? (
              <>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Points</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {wahooResults.map((team, i) => {
                      return (
                        <Tr>
                          <Td>{i+1}</Td>
                          <Td>{team.boatName}</Td>
                          <Td>{team.points}</Td>
                        </Tr>
                      )
                    })}
                  </Tbody>
                </Table>
              </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>#</Th>
                        <Th>Team</Th>
                        <Th>Points</Th>
                      </Tr>
                    </Thead>
                  </Table>
                  <p>No fish caught yet</p>
                </>
              )}
              <p>{wahooDescription}</p>
            </div>
            <br/>
            <br/>
           
            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{tunaTitle}</h3>
              </div>
              <Table>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Team</Th>
                      <Th>Points</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>1</Td>
                      <Td>Overnight Celebrity</Td>
                      <Td>15</Td>
                    </Tr>
                    <Tr>
                      <Td>2</Td>
                      <Td>Trophy Club</Td>
                      <Td>12</Td>
                    </Tr>
                    <Tr>
                      <Td>3</Td>
                      <Td>Poured Out</Td>
                      <Td>12</Td>
                    </Tr>
                    <Tr>
                      <Td>4</Td>
                      <Td>Ambush</Td>
                      <Td>12</Td>
                    </Tr>
                    <Tr>
                      <Td>5</Td>
                      <Td>Ambush</Td>
                      <Td>11</Td>
                    </Tr>
                  </Tbody>
                </Table>
              <p>{tunaDescription}</p>
            </div>
            <br/>
            <br/>

            <div className="resultsTable">
              <div className="resultsContent">
                <h3>{recentCatchTitle}</h3>
              </div>
              <Table>
                <Thead>
                  <Tr>
                    <Th>Species</Th>
                    <Th>Boat</Th>
                    <Th>Date</Th>
                    <Th>Time (24h)</Th>
                    <Th>Points</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {recentCatchList.map((team, i) => {
                    return (
                      <Tr>
                        <Td>{team.fish}</Td>
                        <Td>{team.boatName}</Td>
                        <Td>{team.date.split("T")[0]}</Td>
                        <Td>{team.time}</Td>
                        <Td>{team.points}</Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </div>
            <br/>
            <br/> 

          </div>
        </>
      ) : (
        <></>
      ) }

      { alignment == "pot" ? (
        <>
          <h2>Fish Pot Standings</h2>
          <p>Coming soon...</p>
        </>
      ) : (
        <></>
      )}

      { alignment == "stats" ? (
        <>
          <h2>Tournament Stats</h2>
          <div className="container">
            <div className="resultsTableSmall">
              <Table>
                <Tbody>
                  <Tr>
                    <Td>Total Catches</Td>
                    <Td>{numCatches}</Td>
                  </Tr>
                  <Tr>
                    <Td>Total Billfish</Td>
                    <Td>{numBillfish}</Td>
                  </Tr>
                  <Tr>
                    <Td>Blue Marlin</Td>
                    <Td>{numBlueMarlin}</Td>
                  </Tr>
                  <Tr>
                    <Td>White Marlin</Td>
                    <Td>{numWhiteMarlin}</Td>
                  </Tr>
                  <Tr>
                    <Td>Sailfish</Td>
                    <Td>{numSailfish}</Td>
                  </Tr>
                  <Tr>
                    <Td>Spearfish</Td>
                    <Td>{numSpearfish}</Td>
                  </Tr>
                  <Tr>
                    <Td>Dolphin (Dorado, Mahi)</Td>
                    <Td>{numDolphin}</Td>
                  </Tr>
                  <Tr>
                    <Td>Wahoo</Td>
                    <Td>{numWahoo}</Td>
                  </Tr>
                  <Tr>
                    <Td>Tuna</Td>
                    <Td>{numTuna}</Td>
                  </Tr>
                </Tbody>
              </Table>
            </div>
          </div>

        </>
      ) : (
        <></>
      )}
  </>
}

export default PublicResults;

